import React, { useState } from "react";
import Alert, { AlertColor} from '@mui/material/Alert';
import ErrorIcon from "@mui/icons-material/Error";
import CheckIcon from '@mui/icons-material/Check';
import './Admin.css';
import RTEditor from '../../utils/RTEditor';
import { saveConferenceInfo } from "../../services/ConferenceInformation";

export default function MissionStatement({ conferenceInfo, onConferenceInfoUpdate }: { conferenceInfo: any, onConferenceInfoUpdate: () => void }) {
  const [isAlertMessage, setisAlertMessage] = useState(false);
  const [alertType, setAlertType] = useState<AlertColor>('success');
  const [alertMessage, setAlertMessage] = useState('');
    const handleSave = async (editorContent: string) => {
      if (conferenceInfo?.MissionStatement !== editorContent) {
        if(conferenceInfo!==undefined){
          conferenceInfo.MissionStatement=editorContent;
          try{
            await saveConferenceInfo(conferenceInfo);
            onConferenceInfoUpdate();
            setisAlertMessage(true);
            setAlertType('success');
            setAlertMessage('Successfully saved Mission Statement!')
          }
          catch (error) {
            setAlertType('error');
            setAlertMessage('Failed to save Mission Statement, Please try again.');
            setisAlertMessage(true);
          } finally {
            setTimeout(() => {
              setisAlertMessage(false);
            }, 5000);
          }
        }
      }
    };
return (
  <div className="Margin">
    {isAlertMessage && (
      <Alert icon={alertType === 'success' ? <CheckIcon fontSize="inherit" /> : <ErrorIcon fontSize="inherit" />} severity={alertType}>
        {alertMessage}
      </Alert>
    )}
    <div className="EditorContainer">
      <RTEditor editorName={"Mission Statement"} 
        content={conferenceInfo?.MissionStatement} 
        saveContent={handleSave} />
    </div>
  </div>
  );
}
